import './tailwind.css'
import 'flag-icons/css/flag-icons.min.css'
import './setupAnalytics'
import '@fontsource-variable/reddit-sans'

import ReactDOM from 'react-dom/client'
import { StoreProvider } from 'easy-peasy'
import { initializeSmartyStreets } from '@branch-messenger/willow-ui'
import { DialogProvider } from '@context/DialogContext'
import { ThemeProvider } from '@context/ThemeContext'
import { queryClient } from '@lib/queryClient'
import { router, routerContext } from '@lib/router'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { HandlerScenarios } from './mocks/handlers'
import { store } from './store'

initializeSmartyStreets(import.meta.env.VITE_SMARTY_AUTH_ID)

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://84ae075fc0b243ef82f09322fb125274@o102336.ingest.sentry.io/6009203',
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.browserSessionIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: [import.meta.env.VITE_SENTRY_APPLICATION_KEY],
        behaviour: 'apply-tag-if-contains-third-party-frames',
      }),
    ],
    tracesSampleRate: 0.8,

    // Disable replays for now
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
}

async function enableMocking() {
  if (!import.meta.env.DEV) {
    return
  }

  const scenario = new URLSearchParams(window.location.search).get('scenario')
  if (!scenario) {
    return
  }

  const { getWorker } = await import('./mocks/browser')
  return getWorker(scenario as HandlerScenarios).start()
}

enableMocking().then(() => {
  const rootElement = document.getElementById('root')!
  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
      <QueryClientProvider client={queryClient}>
        <StoreProvider store={store}>
          <ThemeProvider>
            <DialogProvider>
              <RouterProvider context={routerContext} router={router} />
            </DialogProvider>
          </ThemeProvider>
        </StoreProvider>
      </QueryClientProvider>
    )
  }
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
